import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../helpers/language-context';
import { supabase } from '../../../supabaseClient';

const MembershipCard = ({ membership }) => {
  const { language } = useLanguage();
  const [isHovered, setIsHovered] = useState(false);

  const title = membership['name'];
  const description = language === 'en' ? membership['description_en'] : membership['description_ms'];
  const logo = membership['logo'];

  return (
    <div className="flex flex-col space-y-4"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="relative bg-white p-8 rounded-2xl cursor-pointer transition-all duration-300 border-2 border-transparent hover:border-[#FDA729] hover:scale-105 group flex items-center justify-center aspect-square md:h-48 lg:h-56"
      >
        <img
          src={logo}
          alt={title}
          className="w-[70%] h-auto max-h-full object-contain"
        />
      </div>
      <div className="flex flex-col space-y-2 px-2">
        <h3 className={`text-lg font-bold leading-snug transition-colors duration-300 ${
            isHovered ? 'text-[#28357B]' : 'text-[#444444]'
            }`}>{title}</h3>
        <p className={`text-sm transition-colors duration-300 ${
            isHovered ? 'text-gray-600' : 'text-gray-500'
            }`}>
            {description}
        </p>
      </div>
    </div>
  );
};

export default function MembershipList() {
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    const fetchMemberships = async () => {
      const { data, error } = await supabase
        .from('memberships')
        .select('*')
        .order('id', { ascending: true });
      if (!error) setMemberships(data);
    };
    fetchMemberships();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {memberships.map((membership, index) => (
            <MembershipCard key={index} membership={membership} />
        ))}
    </div>
  );
}